export default "__VITE_ASSET__BA$Gbha2__"